// tippi/src/components/driver/CarrierOrderInfo.js
import React from 'react';
import { isCarrierOrder } from '../../utils/carrierOrder';
import { COLORS } from '../../styles/tokens';

// Kunden og notatet fra dispatcher, vist på sjåførens oppdrag for egne ordre.
export default function CarrierOrderInfo({ order }) {
  if (!isCarrierOrder(order)) return null;
  const customer = order.customer ?? {};
  return (
    <section aria-label="Kunde" style={styles.box}>
      <div style={styles.label}>Kunde</div>
      <div style={styles.name}>{customer.name}</div>
      {customer.contactName && <div style={styles.line}>Kontakt: {customer.contactName}</div>}
      {customer.phone && <a href={`tel:${customer.phone}`} style={styles.phone}>Ring {customer.phone}</a>}
      {order.dispatcherNote && (
        <>
          <div style={{ ...styles.label, marginTop: 12 }}>Notat fra dispatcher</div>
          <div style={styles.line}>{order.dispatcherNote}</div>
        </>
      )}
    </section>
  );
}

const styles = {
  box:   { background: COLORS.white, border: `1px solid ${COLORS.border}`, borderRadius: 18, padding: 16, marginBottom: 16 },
  label: { fontSize: 11, color: COLORS.textLight, textTransform: 'uppercase', letterSpacing: 0.3 },
  name:  { fontSize: 17, fontWeight: 700, color: COLORS.textDark, marginTop: 2 },
  line:  { fontSize: 14, color: COLORS.textMid, marginTop: 2, lineHeight: 1.5 },
  phone: { display: 'inline-block', marginTop: 8, fontWeight: 700, color: COLORS.textDark },
};
